import { Infobox } from "@digipost/dds-infobox-react";
import { FC } from "react";

import Translated from "../infrastructure/components/Translated";
import { useTranslate } from "../infrastructure/hooks/useTranslate";

export const EpostVerifiseringFullfort: FC = () => {
  const translate = useTranslate();
  return (
    <Infobox
      title={translate("verify.finished.header")}
      variant={"success"}
      level={2}
    >
      <Translated textKey={"verify.finished"} />
    </Infobox>
  );
};
